import type { SVGProps } from 'react';

interface ErrorConeIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function ErrorConeIcon({ className, ...props }: ErrorConeIconProps) {
  return (
    <svg
      width="46"
      height="48"
      viewBox="0 0 46 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M33.8306 28.512L43.6862 32.9998C44.0773 33.1714 44.41 33.4532 44.6437 33.8107C44.8774 34.1682 45.0019 34.586 45.0022 35.0131C45.0024 35.4402 44.8783 35.8582 44.645 36.2159C44.4117 36.5737 44.0793 36.8558 43.6884 37.0279L24.8263 45.6076C24.2531 45.869 23.6304 46.0043 23.0004 46.0043C22.3704 46.0043 21.7477 45.869 21.1745 45.6076L2.31235 37.0059C1.92198 36.8337 1.59007 36.5518 1.35707 36.1944C1.12406 35.837 1 35.4196 1 34.9929C1 34.5663 1.12406 34.1489 1.35707 33.7915C1.59007 33.4341 1.92198 33.1522 2.31235 32.98L12.1768 28.4922"
        fill="#E0DCD7"
      />
      <path
        d="M33.8306 28.512L43.6862 32.9998C44.0773 33.1714 44.41 33.4532 44.6437 33.8107C44.8774 34.1682 45.0019 34.586 45.0022 35.0131C45.0024 35.4402 44.8783 35.8582 44.645 36.2159C44.4117 36.5737 44.0793 36.8558 43.6884 37.0279L24.8263 45.6076C24.2531 45.869 23.6304 46.0043 23.0004 46.0043C22.3704 46.0043 21.7477 45.869 21.1745 45.6076L2.31235 37.0059C1.92198 36.8337 1.59007 36.5518 1.35707 36.1944C1.12406 35.837 1 35.4196 1 34.9929C1 34.5663 1.12406 34.1489 1.35707 33.7915C1.59007 33.4341 1.92198 33.1522 2.31235 32.98L12.1768 28.4922L33.8306 28.512Z"
        stroke="#9A9691"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 1.24805C24.1425 1.24808 25.2524 1.6281 26.1553 2.32812C27.0533 3.02449 27.6956 3.9984 27.9824 5.09766L34.6084 28.5039L34.6562 28.6904C34.8706 29.6238 34.7017 30.5616 34.1953 31.4209C33.6648 32.3211 32.7868 33.1018 31.6807 33.7393C30.5703 34.3792 29.2205 34.8798 27.7305 35.2197C26.2387 35.5601 24.6256 35.7353 22.998 35.7354C21.3703 35.7354 19.7566 35.5601 18.2646 35.2197C16.7747 34.8798 15.4248 34.3792 14.3145 33.7393C13.2085 33.1019 12.3313 32.3209 11.8008 31.4209C11.2607 30.5044 11.1033 29.4985 11.3867 28.5039L18.0166 5.09766C18.3034 3.99842 18.9458 3.02451 19.8438 2.32812C20.7467 1.62797 21.8574 1.24805 23 1.24805Z"
        stroke="#FFFCF7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.5487 31.0396C33.9941 30.2839 34.1095 29.4893 33.8872 28.7093L27.1324 3.5H18.863L12.108 28.7093C11.8858 29.4893 12.0012 30.2839 12.4465 31.0396C12.8919 31.7953 13.6567 32.4943 14.6892 33.0894C15.7218 33.6844 16.998 34.1616 18.4314 34.4887C19.8648 34.8157 21.422 34.985 22.9976 34.985C24.5732 34.985 26.1305 34.8157 27.5639 34.4887C28.9973 34.1616 30.2735 33.6844 31.306 33.0894C32.3386 32.4943 33.1034 31.7953 33.5487 31.0396Z"
        fill="#F6F2ED"
        stroke="#9A9691"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9116 23.673C29.4604 23.2776 30.7996 22.7043 31.8193 22L29.1398 12C28.4266 12.3333 26.334 13.5 23.134 13.5C19.934 13.5 17.6667 12.3333 17 12L14 22C15.0198 22.7043 16.359 23.2776 17.9078 23.673C19.4565 24.0684 21.1707 24.2746 22.9097 24.2746C24.6486 24.2746 26.3628 24.0684 27.9116 23.673Z"
        fill="#EAE6E1"
        stroke="#9A9691"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="35.5" y="2.5" width="9" height="9" rx="4.5" fill="#F6F2ED" />
      <rect x="35.5" y="2.5" width="9" height="9" rx="4.5" stroke="#9A9691" strokeWidth="0.8" />
      <path
        d="M39.625 7.37541V5.12506C39.625 4.91792 39.7929 4.75 40 4.75C40.2071 4.75 40.375 4.91792 40.375 5.12506V7.37541C40.375 7.58255 40.2071 7.75047 40 7.75047C39.7929 7.75047 39.625 7.58255 39.625 7.37541Z"
        fill="#9A9691"
      />
      <ellipse cx="40.0025" cy="8.87506" rx="0.377502" ry="0.375059" fill="#9A9691" />
      <path d="M23 43.5L45 34" stroke="#9A9691" />
      <path d="M23 43.5L1 34" stroke="#9A9691" />
      <path d="M23 43.5V46" stroke="#9A9691" />
      <path
        d="M23 2C24.1893 2 25.2418 2.2156 25.9785 2.54297C26.3475 2.70696 26.6155 2.88921 26.7842 3.06641C26.9503 3.24098 27 3.38657 27 3.5C27 3.61343 26.9503 3.75902 26.7842 3.93359C26.6155 4.11079 26.3475 4.29304 25.9785 4.45703C25.2418 4.7844 24.1893 5 23 5C21.8107 5 20.7582 4.7844 20.0215 4.45703C19.6525 4.29304 19.3845 4.11079 19.2158 3.93359C19.0497 3.75902 19 3.61343 19 3.5C19 3.38657 19.0497 3.24098 19.2158 3.06641C19.3845 2.88921 19.6525 2.70696 20.0215 2.54297C20.7582 2.2156 21.8107 2 23 2Z"
        fill="#9A9691"
        stroke="#9A9691"
      />
    </svg>
  );
}
